<template>
  <div class="comp-invoice fit-height">
    <div v-if="INVOICE">
      <div class="invoice-head details-head">
        <div class="inn">
          <div class="info">
            <ul class="meta">
              <li>Invoice #{{ INVOICE.invoice_number }}</li>
              <li>
                <div class="dropdown">
                  <a href="javascript:;" class="status dropdown-toggle" :class="status" data-toggle="dropdown" @click="showStatusDropdown = !showStatusDropdown">{{ status | statusToUCWords}}</a>
                  <div class="dropdown-menu" :class="{show: showStatusDropdown == true}">
                    <a class="dropdown-item" href="javascript:;" @click="updateStatus(jstatus)" v-for="jstatus in invoiceStatuses" :key="jstatus" :value="jstatus">
                      {{ jstatus | statusToUCWords }}
                    </a>
                  </div>
                </div>
              </li>
            </ul>
            <div class="title">
              <template v-if="editInvoiceName">
                <form method="post" action="" @submit.prevent="updateName">
                  <input type="text" class="form-control" v-model="newInvoiceName" ref="inputName" @blur="updateName">
                </form>
              </template>
              <template v-else>
                <span>{{ INVOICE.name }}</span>
                <a href="javascript:;" class="edit icon-pencil"
                   @click="editInvoiceName = true"></a>
              </template>
            </div>
          </div>
          <div class="btns">
            <button type="button" class="btn btn-outline-gray w150" @click="confDuplicate">Duplicate</button>&nbsp;
            <button type="button" class="btn btn-outline-black w150" @click="downloadPDF">Download</button>
          </div>
        </div>
      </div>
      <div class="auto-height">
        <div class="tabs">
          <ul>
            <li v-for="(tab, index) in tabs" :key="index">
              <a href="javascript:;" :class="{active: curTab==tab.value}" @click="curTab = tab.value">
                {{ tab.label }}
              </a>
            </li>
          </ul>
        </div>

        <div class="tab-ct">
          <invoice-details v-if="curTab == 'details'"></invoice-details>
          <related-quotes :reload="childKey.quote" @item-saved="onItemSaved" v-if="curTab == 'quote'"></related-quotes>
          <related-time :reload="childKey.time" @item-saved="onItemSaved" v-if="curTab == 'time'"></related-time>
          <related-orders :reload="childKey.order" @item-saved="onItemSaved" v-if="curTab == 'order'"></related-orders>
          <related-tasks :reload="childKey.task" @item-saved="onItemSaved" v-if="curTab == 'task'"></related-tasks>
        </div>

        <div class="invoice-items">
          <div class="table-responsive" style="overflow: visible;">
            <table class="table table-sm">
              <thead>
              <tr>
                <th width="70">TYPE</th>
                <th width="120">CATEGORY</th>
                <th width="200">ITEM</th>
                <th>DETAILS</th>
                <th width="90">QTY/HOURS</th>
                <th width="100">INVOICE RATE</th>
                <th width="100">INVOICED</th>
                <th width="90">GST</th>
                <th width="130">INVOICED INC. GST</th>
                <th width="70"></th>
              </tr>
              </thead>
              <tbody>
              <template v-for="(item, index) in invoiceItems">
                <invoice-item-row :item="item" :key="index" :idx="index" @item-saved="onItemSaved" @item-deleted="onItemDeleted"></invoice-item-row>
              </template>
              <invoice-item-row v-if="isAdding" idx="-1" @item-saved="onItemSaved" @item-cancelled="onItemCancelled"></invoice-item-row>
              </tbody>
            </table>
          </div>

          <div class="text-center">
            <button v-if="!isAdding" type="button" class="btn btn-outline-black w180" @click="isAdding = true">Add Item</button>
          </div>
        </div>

        <div class="invoice-summary">
          <div class="table-responsive">
            <table class="table">
              <tbody>
              <tr>
                <td>TOTAL</td>
                <td width="190">${{ totalInvoiced | numberFormat }}</td>
                <td width="200">${{ totalInvoiced*1.1 | numberFormat }} INC. GST</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters, mapState} from 'vuex'
import ServiceInvoice from '@/services/invoice'
import ModalDuplicate from './ModalDuplicate';

import InvoiceDetails from './InvoiceDetails';
import RelatedQuotes from './RelatedQuotes';
import RelatedTime from './RelatedTime';
import RelatedOrders from './RelatedOrders';
import RelatedTasks from './RelatedTasks';
import InvoiceItemRow from './InvoiceItemRow';

export default {
  components: {
    InvoiceDetails,
    RelatedQuotes,
    RelatedTime,
    RelatedOrders,
    RelatedTasks,
    InvoiceItemRow
  },
  data () {
    return {
      state: '',
      status: 'pending',
      updated_dtm: 0,
      editInvoiceName: false,
      newInvoiceName: '',
      showStatusDropdown: false,
      tabs: [
        {value: 'details', label: 'INVOICE DETAILS'},
        {value: 'quote', label: 'RELATED QUOTES'},
        {value: 'time', label: 'RELATED TIME'},
        {value: 'order', label: 'RELATED ORDERS'},
        {value: 'task', label: 'RELATED TASKS'},
      ],
      curTab: 'details',
      invoiceItems: [],
      isAdding: false,
      childKey: {
        quote: 1,
        time: 1,
        order: 1,
        task: 1
      }
    }
  },
  props: ['invoiceId'],
  watch: {
    invoiceId (newVal) {
      if ( newVal && this.INVOICE && this.INVOICE.id != newVal )
        this.init();
    },
    editInvoiceName (newVal) {
      let self = this;
      if ( newVal ) {
        self.newInvoiceName = self.INVOICE.name;
        setTimeout(() => {
          self.$refs.inputName.focus();
        }, 200);
      }
    }
  },
  computed: {
    ...mapGetters(['INVOICE', 'JOB']),
    ...mapState({
      invoiceStatuses: state => state.option.invoiceStatuses
    }),
    totalInvoiced () {
      let self = this, total = 0;
      if(self.invoiceItems.length){
        for(let i = 0; i < self.invoiceItems.length; i++){
          let item = self.invoiceItems[i];
          total += item.amount?parseFloat(item.amount):parseFloat(item.rate*item.quantity);
        }
      }
      return total;
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      self.isAdding = false;
      self.$store.dispatch('GET_INVOICE', self.invoiceId)
        .then(() => {
          self.populateData();
        });
    },
    populateData () {
      let self = this;
      self.status = self.INVOICE.status;
      self.invoiceItems = self.INVOICE.items;
      if (self.INVOICE.job_id) {
        self.$store.dispatch('GET_JOB', self.INVOICE.job_id);
      }
    },
    updateName () {
      let self = this;
      // save to DB
      setTimeout(() => {
        if(self.newInvoiceName != self.INVOICE.name){
          self.INVOICE.name = self.newInvoiceName;
          self.saveInvoice({name: self.newInvoiceName});
        }
        self.editInvoiceName = false;
      }, 1000);
    },
    updateStatus (newStatus) {
      let self = this;
      if(newStatus && newStatus != self.status){
        self.status = newStatus;
        self.saveInvoice({status: newStatus}, function(invoice){
          if (invoice.xero_invoice_id && invoice.xero_invoice_id != '00000000-0000-0000-0000-000000000000') {
            self.$notify({
              type: 'success',
              text: 'Invoice synced to XERO',
              duration: 5000
            });
          }
        });
      }
      self.showStatusDropdown = false;
    },
    saveInvoice (updateData, callback) {
      let self = this;
      if (self.state == 'saving') {
        return;
      }
      if (updateData == null) {
        updateData = {};
        Object.assign(updateData, self.postData);
      }

      self.state = 'saving';
      ServiceInvoice.save(self.INVOICE.id, updateData, invoice => {
        let now = new Date().getTime();
        if(now - self.updated_dtm > 5*1000){
          self.$notify({
            type: 'success',
            text: 'Invoice updated'
          });
          self.updated_dtm = now;
        }
        if (typeof callback == "function")
          callback(invoice);
        self.state = '';
        self.$store.dispatch('UPDATE_INVOICE', invoice).then(() => {
          self.populateData();
        });
      }, () => {
        self.state = '';
      });
    },
    confDuplicate () {
      let self = this;

      self.$modal.show(ModalDuplicate, {
        invoice: self.INVOICE
      }, {
        clickToClose: false,
        width: 592
      });
    },
    onItemCancelled () {
      this.isAdding = false;
    },
    onItemSaved ( item, index ) {
      let self = this;
      if(index != -1)
        self.invoiceItems.splice( index, 1, item );
      else
        self.invoiceItems.push( item );
      self.isAdding = false;
    },
    onItemDeleted (index) {
      let self = this;
      if (typeof self.invoiceItems[index] != 'undefined') {
        let item = self.invoiceItems[index];
        self.invoiceItems.splice(index, 1);
        self.$notify({
          type: 'success',
          text: '<strong>' + window.stringToUCWords(item.type) + ' - ' + item.description + '</strong> item is deleted'
        });
        if (item.type == self.curTab ) {
          self.childKey[self.curTab] = new Date().getTime();
        }
      }
    },
    downloadPDF () {
      let self = this;
      if ( self.status == 'processing' ) {
        return;
      }
      self.state = 'processing';
      ServiceInvoice.downloadPDF(self.INVOICE.id, resp => {
        self.state = '';
        window.downloadFromBlob(resp.data, 'invoice_' + self.INVOICE.id + '.pdf');
      }, () => {
        self.state = '';
      });
    },
    duplicateItem ( index ) {
      let self = this;
      self.invoiceItems.splice( index, 0, self.invoiceItems[index] )
    },
  }
}
</script>
